import { useEffect, useState } from "react";

import { AppAlert } from "../../components/utilities/alert";
import { serverUrl } from "../../services/configs/server";
import { BmsHeader } from "../../components/main-components/app.header";

export const EmailVerification = () => {

    const verificationToken = new URLSearchParams(window.location.search).get("token");

    const [onAlert, setOnAlert] = useState();

    useEffect(() => {
        (async () => {
            const verifyEmail = (token) => {
                return fetch(`${serverUrl}/accounts/verification/${token}`, {
                    method: "POST",
                    mode: "cors"
                });
            }
            const response = await verifyEmail(verificationToken);
            const res = await response.json();
            setOnAlert({
                caption: 'Success!',
                message: res?.message,
                accept: "Ok",
                onAccept: () => {
                    setOnAlert();
                    window.location.href = "/"
                },
            })
        })();
    }, [verificationToken])

    return (
        <div className="">
             <BmsHeader />
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    acceptAction={onAlert.onAccept}
                    close={() => setOnAlert()}
                />
            )}
        </div>
    )
}